module.exports = __webpack_public_path__ + "static/media/replicating-viral-vector.1916a90f.jpg";